<template>
  <div class="rankWork">
    <div class="header">
      <div class="back" @click="goback">
        <img src="./../../assets/img/go_back.png" alt="">
        <span>返回</span>
      </div>
      <h2>{{workName}}</h2>
      <div class="tips">
        <img src="../../../static/new icon/down.png" alt="" @click="showInfo">
        <div class="info down" v-show="isShow">
          <ul>
            <li>
              <span>布置对象</span>
              <p>{{reviceObject}}</p>
            </li>
            <li>
              <span>所属书籍</span>
              <p>{{workList.bookName}}</p>
            </li>
            <li>
              <span>布置时间</span>
              <p v-if="workList.state == 0 || workList.state == -1">{{workList.publishDate | formatDate('yyyy-MM-dd W hh:mm')}}</p>
              <p v-else-if="workList.state == 1 || workList.state == -1">{{workList.sendDate | formatDate('yyyy-MM-dd W hh:mm')}}</p>
            </li>
            <li>
              <span>截止时间</span>
              <p>{{workList.effectiveDate | formatDate('yyyy-MM-dd W hh:mm')}}</p>
            </li>
            <li>
              <span>作业留言</span>
              <p>{{workList.workMessage}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="workContent clearfix">
      <div class="leftBox fl">
        <div class="summaryContent">
          <ul>
          <h3 class="summaryStudentTitle">按学生查看</h3>
          <li @click="tabFun(-1)">
            <span class="summaryStudentClick" :class="{currentWork:activeIndex == -1}">成绩汇总</span>
          </li>
          <h3 class="summaryContentTitle">按内容查看</h3>
            <li  v-for="(item, index) in contentList" :key="index" @click="tabFun(index, item.contentId)" 
            :class="{currentWork:index == activeIndex}">
            <i class="icon-correct" v-if="item.correctMark"></i>{{item.resourceName}}
            </li>
          </ul>
        </div>
      </div>
      <rankWorkTable :collectHeader="collectHeader" :workScore="workScore" :collectData="collectData" v-if='activeIndex == -1'></rankWorkTable>
      <rankTable :rankTableData="rankTableData" :singleData="singleData" :workId="workId" :contentId="contentId" :url="url" :activeIndex="activeIndex" :hasQuestion="hasQuestion" v-if='activeIndex!=-1'></rankTable>
    </div>
  </div>
</template>
<script>
import fetch from "./../../fetch";
import rankTable from "../rankTable/rankTable.vue";
import rankWorkTable from "../rankWorkTable/rankWorkTable.vue";
import rankError from "../rankError/rankError.vue";
import { clientId, brandId, http } from "./../../config";
export default {
  data() {
    return {
      workList: "",
      workName: "",
      contentList: "",
      activeIndex: -1, //tab索引
      collectData: "",
      averageGrad: 0,
      isShow: false,
      collectHeader: [],
      workScore: "",
      rankTableData: "",
      singleData: "",
      reviceObject: "",
      hasQuestion: true,
      workId:'',
      contentId:'',
      url: ''
    };
  },
  components: {
    rankTable,
    rankWorkTable,
    rankError
  },
  created() {
    this.$nextTick(() => {
      this.workList = this.$route.query;
      this.activeIndex = this.workList.index;
      this.workId = this.workList.workId;
      this.toFetchStatistics(this.workId);
      this.reviceObject = this.$route.query.reviceObject;
    });
  },

  methods: {
    goback() {
      this.$router.push({ path: "home" });
    },
    showInfo() {
      this.isShow = !this.isShow;
    },
    // 点击激活状态
    tabFun(index, contentId) {
      this.activeIndex = index;
      if (index > -1) {
        this.getFinishier(contentId);
      } else {
        this.toFetchStatistics(this.workId);
      }
    },
    //获取成绩汇总
    toFetchStatistics(workId) {
      const that = this;
      fetch.getEworkStatistics({ workId }).then(res => {
        if (!res) {
          return false;
        }
        that.filteData(res.data);
      });
    },
    filterStudents(headerData, newTabDatas) {
      let array = [];
      const len = newTabDatas.length;
      headerData.map(hItem => {
        let i = 0;
        for (let index = 0; index < len; index++) {
          const element = newTabDatas[index];
          if (element.id == hItem.id) {
            const newData = Object.assign({}, hItem, element);
            array.push(newData);
            break;
          }
          i++;
        }
        if (i === len) {
          array.push({
            score: "未提交"
          });
        }
      });
      return array;
    },
    filteData(workData) {
      this.workName = workData.work.workName;
      this.contentList = workData.work.contentList;
      let headerData = workData.header[2];
      this.collectHeader = headerData;
      this.workScore = workData.header[3];
      let students = workData.receivers;
      let records = workData.records;
      const $this = this;
      this.setCorrectMark(records)
      this.collectData = students.map(sItem => {
        let unreceiver = 0;
        if (!sItem.tabDatas) {
          let tabDatas = [];
          this.contentList.map(c_item => {
            tabDatas.push({
              score: "未提交"
            });
          });
          sItem.tabDatas = tabDatas;
        }
        for (let j = 0, lens = records.length; j < lens; j++) {
          const item = records[j];
          const newTabDatas = item.tabDatas;
          const len = newTabDatas.length;

          if (sItem.userId === item.userId) {
            unreceiver = 0
            if (headerData.length !== len) {
              item.tabDatas = $this.filterStudents(
                headerData,
                newTabDatas
              );
            }
            sItem = Object.assign({}, sItem, item);
            break;
          }
          unreceiver ++ 
        }
        if (unreceiver) {
          const tabDatas = $this.filterStudents(
                headerData,
                []
              );
          sItem = Object.assign({}, sItem, {tabDatas,totalScore:0});
        }
        return sItem;
      });
      
      // 成绩汇总时候，显示方式按照总分从高到低显示
      let newData = this.collectData;
      for (let index = 0; index < newData.length; index++) {
        for (let j = index + 1; j < newData.length; j++) {
          if (newData[index].totalScore < newData[j].totalScore) {
            var temp = newData[index];
            newData[index] = newData[j];
            newData[j] = temp;
          }
        }
      }
      this.collectData = newData
      if (this.activeIndex > -1) {
        let contentId = this.contentList[this.activeIndex].contentId;
        this.getFinishier(contentId);
      }
    },
    setCorrectMark (records) {
        let contentList  = this.contentList
        contentList.map(item => {
          item.correctMark = false
          records.map(ritem => {
            for(let i = 0, len = ritem.tabDatas.length; i < len; i++) {
              let sitem = ritem.tabDatas[i]
              if (sitem.id == item.contentId && (sitem.workStatus == 15 || sitem.workStatus == 17)) {
                item.correctMark = true
              }
            }
          })
        })
        this.contentList = contentList
    },
    // 获取单个作业数据
    getFinishier(contentId) {
      this.contentId = contentId
      let user = JSON.parse(window.localStorage.getItem('user'))
      this.url = http + "/gateway/v1/epaperstatistics/exportContentReport?" + 'clientId='+ clientId +'&contentId=' + this.contentId + "&accessToken=" + user.accessToken;
      const params = {
        contentId: contentId,
        workId: this.workId
      };
      fetch.finishier(params).then(res => {
        if (!res) {
          return false;
        }
        this.hasQuestion = res.data[0].hasQuestion;
        this.rankTableData = res.data;
        this.average();
        this.singleData = {
          resourceName: this.contentList[this.activeIndex].resourceName,
          moduleId: this.contentList[this.activeIndex].moduleId,
          speekingtype: JSON.parse(
            this.contentList[this.activeIndex].requirementContent
          ).speekingtype,
          readtimes: JSON.parse(
            this.contentList[this.activeIndex].requirementContent
          ).readtimes,
          averageGrad: this.averageGrad,
          count: this.count,
          resourceType: this.contentList[this.activeIndex].resourceType,
          workScore: this.contentList[this.activeIndex].workScore
        };
      });
    },
    average() {
      let count = 0;
      let score = 0;
      this.rankTableData.map(item => {
        if (item.submitDate) {
          score += item.actualScore;
          count++;
        }
      });
      this.averageGrad = score ? score / count : 0;
      this.count = count;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rankWorkWeb.vue?1de3b402